/**
 * Android main-screen auth dock: fully opaque surfaces (no blur / no fade).
 * iOS keeps animated `overlayPanelTransform` fills and frosted chrome unchanged.
 */
import { Platform, type ViewStyle } from 'react-native';
import type { ThemeColors } from '../theme/store';

export function isAndroidMainScreenFormOpaque(): boolean {
  return Platform.OS === 'android';
}

/** Outer crossfade shell behind login ↔ register layers. */
export function androidMainScreenAuthFormShellSurface(colors: ThemeColors): ViewStyle | null {
  if (!isAndroidMainScreenFormOpaque()) {
    return null;
  }
  return { backgroundColor: colors.surface };
}

/** Absolute-fill layer so crossfading forms never show hero through gaps. */
export function androidMainScreenAuthFormLayerSurface(colors: ThemeColors): ViewStyle | null {
  if (!isAndroidMainScreenFormOpaque()) {
    return null;
  }
  return { backgroundColor: colors.surface };
}

/** ScrollView content fill for intrinsic main-screen credential forms. */
export function androidMainScreenAuthFormScrollSurface(colors: ThemeColors): ViewStyle | null {
  if (!isAndroidMainScreenFormOpaque()) {
    return null;
  }
  return { backgroundColor: colors.surface };
}
